export default __webpack_public_path__ + "static/media/AE2.4ef7a227.jpg";